import React from 'react';
import { HStack, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';
import { LegalDocType } from './legalContent';

const linkButtonStyles = {
  cursor: 'pointer' as const,
  bg: 'transparent',
  border: 'none',
  p: 0,
};

interface LegalPolicyLinksProps {
  onOpen: (doc: LegalDocType) => void;
  color: string;
  hoverColor: string;
  fontSize?: string;
  layout?: 'horizontal' | 'vertical';
}

const LINKS: { doc: LegalDocType; label: string }[] = [
  { doc: 'terms', label: 'Terms of Service' },
  { doc: 'privacy', label: 'Privacy Policy' },
  { doc: 'cookies', label: 'Cookie settings' },
];

const LegalPolicyLinks: React.FC<LegalPolicyLinksProps> = ({
  onOpen,
  color,
  hoverColor,
  fontSize = 'sm',
  layout = 'horizontal',
}) => {
  const link = (doc: LegalDocType, label: string) => (
    <Text
      key={doc}
      as="button"
      type="button"
      {...linkButtonStyles}
      fontSize={fontSize}
      color={color}
      _hover={{ color: hoverColor, textDecoration: 'underline' }}
      onClick={() => onOpen(doc)}
    >
      {label}
    </Text>
  );

  if (layout === 'vertical') {
    return (
      <VStack align="start" spacing={3}>
        {LINKS.map(({ doc, label }) => link(doc, label))}
      </VStack>
    );
  }

  return (
    <HStack spacing={4} flexWrap="wrap">
      {LINKS.map(({ doc, label }) => link(doc, label))}
    </HStack>
  );
};

export default LegalPolicyLinks;
